<template>
  <div>
    <v-app-bar app elevation="1" color="primary" dark height="60px">
      <router-link to="/" class="d-flex align-center" style="height:100%">
        <logo style="height: 40px; width: auto" />
      </router-link>
    </v-app-bar>
    <v-main>
      <v-container style="max-width:900px" class="py-8">

        <div class="text-center mb-6">
          <div class="text-h5 font-weight-bold mb-1">Formular Netzbetrieb</div>
        </div>

        <v-alert v-if="submitError" type="error" class="mb-4">{{ submitError }}</v-alert>

        <!-- Success -->
        <v-card v-if="success" class="pa-8 text-center" elevation="2">
          <v-icon color="success" size="56" class="mb-4">{{ mdiCheckCircle }}</v-icon>
          <div class="text-h6 mb-3">Formular erfolgreich übermittelt!</div>
          <div class="body-1 mb-4">
            Vielen Dank! Bitte laden Sie Ihre <strong>Vertretungsberechtigung</strong> und <strong>Ausweiskopien</strong>
            über folgenden Link hoch:
          </div>
          <v-btn color="primary" href="https://dateiaustausch.wolff.holdings/s/eWYTs863LP4eELe" target="_blank" large>
            Dateiupload öffnen
          </v-btn>
        </v-card>

        <!-- Stepper -->
        <v-stepper v-else v-model="step" class="elevation-2">
          <v-stepper-header>
            <v-stepper-step :complete="step > 1" step="1" editable :rules="[() => !stepHasError(1) || 'Fehler']">Produkte</v-stepper-step>
            <v-divider />
            <v-stepper-step :complete="step > 2" step="2" editable :rules="[() => !stepHasError(2) || 'Fehler']">Organisation</v-stepper-step>
            <v-divider />
            <v-stepper-step :complete="step > 3" step="3" editable :rules="[() => !stepHasError(3) || 'Fehler']">Konto</v-stepper-step>
            <v-divider />
            <v-stepper-step :complete="step > 4" step="4" editable :rules="[() => !stepHasError(4) || 'Fehler']">Kontakt</v-stepper-step>
            <v-divider />
            <v-stepper-step :complete="step > 5" step="5" editable :rules="[() => !stepHasError(5) || 'Fehler']">Vollmacht</v-stepper-step>
            <v-divider />
            <v-stepper-step step="6" editable :rules="[() => !stepHasError(6) || 'Fehler']">Abschluss</v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>

            <!-- ─── STEP 1 – Produkte ──────────────────────────────────────────── -->
            <v-stepper-content step="1">
              <v-form ref="form1" lazy-validation>

                <div class="subtitle-1 font-weight-medium mb-2">
                  Für welche Produkte benötigen Sie diesen Vertrag?
                </div>
                <div class="body-2 grey--text mb-4">(Mehrfachauswahl möglich)</div>

                <div class="subtitle-2 mb-1">Online-Produkte</div>
                <v-row class="mb-2">
                  <v-col cols="6" sm="3" class="py-1"><v-checkbox v-model="products.ws" label="spende.app" hide-details /></v-col>
                  <v-col cols="6" sm="3" class="py-1"><v-checkbox v-model="products.wa" label="kollekte.app" hide-details /></v-col>
                  <v-col cols="6" sm="3" class="py-1"><v-checkbox v-model="products.va" label="veranstaltung.app" hide-details /></v-col>
                  <v-col cols="6" sm="3" class="py-1"><v-checkbox v-model="products.kg" label="kirchgeld.digital" hide-details /></v-col>
                </v-row>

                <div class="subtitle-2 mt-3 mb-1">Hardware-Produkte</div>
                <v-row class="mb-2">
                  <v-col cols="6" sm="3" class="py-1"><v-checkbox v-model="products.kb" label="Digitaler Klingelbeutel" hide-details /></v-col>
                  <v-col cols="6" sm="3" class="py-1"><v-checkbox v-model="products.sd" label="Digitale Spendendose" hide-details /></v-col>
                  <v-col cols="6" sm="3" class="py-1"><v-checkbox v-model="products.sp" label="Digitale Spendensäule" hide-details /></v-col>
                  <v-col cols="6" sm="3" class="py-1"><v-checkbox v-model="products.wt" label="spende.tap" hide-details /></v-col>
                  <v-col cols="6" sm="3" class="py-1"><v-checkbox v-model="products.so" label="Sonderanfertigung" hide-details /></v-col>
                </v-row>

                <v-alert v-if="showProductAlert && !anyProductSelected" type="warning" dense outlined class="mt-2">
                  Bitte wählen Sie mindestens ein Produkt aus.
                </v-alert>

                <v-divider class="my-4" />

                <div class="body-2 grey--text mb-4">
                  In jedem Spendengerät ist ein Zahlungsterminal verbaut, wie Sie es aus dem Supermarkt kennen.
                  Online-Spenden funktionieren äquivalent.<br>
                  Für den Betrieb wird ein Zahlungsdienstevertrag je (Mutter-)Organisation benötigt.
                  Bitte beachten Sie, dass der Kontoinhaber und der Vertragsnehmer identisch sein müssen.
                  Es dauert etwa 4 Wochen bis die erste Kreditkartenzahlung angenommen werden kann, Girocard geht schneller.
                </div>

                <div class="subtitle-2 mb-2">Bitte halten Sie folgende Unterlagen bereit:</div>
                <ul class="body-2 mb-4" style="padding-left:20px">
                  <li>Anschrift Ihrer Organisation</li>
                  <li>ggf. abweichende Lieferadresse</li>
                  <li>Handels- / Vereins- / etc. Registerauszug zur Feststellung der vertretungsberechtigten Person</li>
                  <li>Wer ist Ansprechpartner</li>
                  <li>Wer ist bei Ihnen unterschriftsberechtigt? Von dieser Person werden eine Personalausweiskopie und die Privatanschrift benötigt.</li>
                  <li>Gläubiger-ID (kann nachgereicht werden)</li>
                  <li>Kontonummer für Spendeneingang und Betriebskosten (ein oder zwei Bankkonten)</li>
                </ul>

              </v-form>
              <div class="d-flex justify-end mt-4 pb-4">
                <v-btn color="primary" @click="tryNextStep1">Weiter</v-btn>
              </div>
            </v-stepper-content>

            <!-- ─── STEP 2 – Organisation ─────────────────────────────────────── -->
            <v-stepper-content step="2">
              <v-form ref="form2" v-model="formValid[2]" lazy-validation>

                <v-row dense class="mb-4">
                  <v-col cols="12" sm="8">
                    <v-text-field v-model="org.name" label="Name der Organisation *" outlined dense :rules="[required]" />
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field v-model="org.shortName" label="Kurzname der Organisation *" outlined dense :rules="[required]"
                      counter="22" maxlength="22" hint="Wird für Kontoauszüge benötigt." persistent-hint />
                  </v-col>
                </v-row>

                <v-row dense class="mb-4">
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="org.street" label="Straße + Nr. *" outlined dense :rules="[required]" />
                  </v-col>
                  <v-col cols="6" sm="2">
                    <v-text-field v-model="org.postcode" label="PLZ *" outlined dense :rules="[required]" />
                  </v-col>
                  <v-col cols="6" sm="4">
                    <v-text-field v-model="org.locality" label="Ort *" outlined dense :rules="[required]" />
                  </v-col>
                </v-row>

                <v-row dense class="mb-4">
                  <v-col cols="12" sm="3">
                    <v-select v-model="org.country" label="Land *" outlined dense :rules="[required]" :items="countries" />
                  </v-col>
                  <v-col cols="12" sm="9">
                    <v-text-field v-model="org.websiteUrl" label="Website der Organisation" outlined dense
                      :rules="[urlRule]" placeholder="https://www.example.de" />
                  </v-col>
                </v-row>

                <div class="mb-4" />

                <v-row dense class="mb-4">
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="org.region" label="Landeskirche / Erzbistum (wenn zutreffend)" outlined dense />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="org.district" label="Kirchenkreis / Bistum (wenn zutreffend)" outlined dense />
                  </v-col>
                </v-row>

                <div class="mb-4" />

                <v-row dense class="mb-4">
                  <v-col cols="12" sm="6">
                    <v-select v-model="org.legalForm" label="Rechtsform *" outlined dense :rules="[required]"
                      :items="legalForms" />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="org.foundingDate" label="Gründungsdatum *" outlined dense
                      placeholder="TT.MM.JJJJ" :rules="[required, dateRule]"
                      hint="Wenn Sie das exakte Gründungsdatum nicht kennen, verwenden Sie den 01. Januar." persistent-hint />
                  </v-col>
                </v-row>

                <v-row v-if="org.legalForm === 'Sonstige'" dense class="mb-4">
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="org.legalFormOther" label="Andere Rechtsform *" outlined dense :rules="[required]" />
                  </v-col>
                </v-row>

                <v-row dense class="mb-4">
                  <v-col cols="12" sm="4">
                    <v-select v-model="org.register" label="Register *" outlined dense :rules="[required]"
                      :items="['Vereinsregister','Handelsregister','Genossenschaftsregister','Stiftungsregister','kein Register']" />
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field v-model="org.registerNumber" label="Register-Nr." outlined dense />
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field v-model="org.registerCourt" label="Registergericht" outlined dense />
                  </v-col>
                </v-row>

                <!-- Registerauszug upload -->
                <v-alert type="info" outlined dense class="mt-2">
                  <strong>Vertretungsberechtigung hochladen:</strong> Bitte laden Sie Ihren Handels-, Vereins- oder sonstige Vertretungsberechtigung über folgenden Link hoch:
                  <a href="https://dateiaustausch.wolff.holdings/s/eWYTs863LP4eELe" target="_blank">
                    Dateiupload öffnen
                  </a>
                </v-alert>

                <div class="mb-4" />

                <v-row dense class="mb-4">
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="org.creditorId" label="Gläubiger-ID" outlined dense />
                    <div class="caption grey--text mt-n3 mb-2">
                      Kann nachgereicht werden. Die Gläubiger-ID wird bei der Bundesbank beantragt –
                      <a href="https://www.bundesbank.de/de/aufgaben/unbarer-zahlungsverkehr/serviceangebot/sepa/glaeubiger-identifikationsnummer/antragstellung-und-ausgabe-602954" target="_blank">Link zur Antragstellung</a>.
                    </div>
                  </v-col>
                </v-row>

              </v-form>
              <div class="d-flex justify-space-between mt-4 pb-4">
                <v-btn text @click="step = 1">Zurück</v-btn>
                <v-btn color="primary" @click="nextStep(2)">Weiter</v-btn>
              </div>
            </v-stepper-content>

            <!-- ─── STEP 3 – Kontoverbindung ─────────────────────────────────── -->
            <v-stepper-content step="3">
              <v-form ref="form3" v-model="formValid[3]" lazy-validation>

                <div class="subtitle-2 mb-2">Wem gehört das Spendeneingangskonto? *</div>
                <div class="body-2 grey--text mb-3">
                  Der Kontoinhaber des Spendeneingangskontos muss den Vertrag Netzbetrieb und die
                  Kreditkartenverträge unterschreiben. In einigen Fällen ist dies die Mutterorganisation.
                  Der Kauf- und Betriebsvertrag wird dann weiterhin auf Ihre Organisation ausgestellt.
                </div>
                <v-radio-group v-model="org.serviceContractSelf" :rules="[required]" row>
                  <v-radio label="Der eigenen Organisation" value="ja" />
                  <v-radio label="Einer Mutterorganisation" value="nein" />
                </v-radio-group>

                <v-text-field v-if="org.serviceContractSelf === 'nein'" v-model="org.parentOrgName"
                  label="Name der Mutterorganisation *" outlined dense :rules="[required]" class="mt-2" />

                <v-divider class="my-4" />

                <div class="subtitle-1 font-weight-medium mb-3">
                  Konto für Zahlungseingänge durch Kollekte oder Spende
                </div>
                <div class="body-2 grey--text mb-3">
                  Kontoinhaber und Vertragsnehmer müssen identisch sein.
                </div>

                <v-row dense class="mb-4">
                  <v-col cols="12" sm="4">
                    <v-text-field v-model="bank.paymentOwner" label="Kontoinhaber *" outlined dense :rules="[required]" />
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field v-model="bank.paymentBankName" label="Kontoführendes Institut *" outlined dense :rules="[required]" />
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field v-model="bank.paymentIban" label="IBAN *" outlined dense :rules="[required, ibanRule]"
                      @blur="bank.paymentIban = formatIban(bank.paymentIban)" />
                  </v-col>
                </v-row>

                <v-divider class="my-4" />

                <div class="subtitle-1 font-weight-medium mb-3">
                  Konto für SEPA-Lastschriftmandat (monatliche Betriebskosten)
                </div>

                <v-row dense class="mb-4">
                  <v-col cols="12" sm="4">
                    <v-text-field v-model="bank.sepaOwner" label="Kontoinhaber (Betriebskosten) *" outlined dense :rules="[required]" />
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field v-model="bank.sepaBankName" label="Kontoführendes Institut (Betriebskosten) *" outlined dense :rules="[required]" />
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field v-model="bank.sepaIban" label="IBAN (Betriebskosten) *" outlined dense :rules="[required, ibanRule]"
                      @blur="bank.sepaIban = formatIban(bank.sepaIban)" />
                  </v-col>
                </v-row>

              </v-form>
              <div class="d-flex justify-space-between mt-4 pb-4">
                <v-btn text @click="step = 2">Zurück</v-btn>
                <v-btn color="primary" @click="nextStep(3)">Weiter</v-btn>
              </div>
            </v-stepper-content>

            <!-- ─── STEP 4 – Ansprechpartner ─────────────────────────────────── -->
            <v-stepper-content step="4">
              <v-form ref="form4" v-model="formValid[4]" lazy-validation>

                <div class="subtitle-1 font-weight-medium mb-3">Ansprechpartner für Organisatorisches</div>

                <v-row dense class="mb-4">
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="contact.firstName" label="Vorname *" outlined dense :rules="[required]" />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="contact.lastName" label="Nachname *" outlined dense :rules="[required]" />
                  </v-col>
                </v-row>

                <v-row dense class="mb-4">
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="contact.role" label="Funktion *" outlined dense :rules="[required]" />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="contact.phone" label="Telefon *" outlined dense :rules="[required]" />
                  </v-col>
                </v-row>

                <v-row dense class="mb-4">
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="contact.email" label="E-Mail Ansprechpartner / Administrator *" outlined dense
                      :rules="[required, emailRule]" type="email" />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="contact.invoiceEmail" label="E-Mail-Adresse für Rechnungen *" outlined dense
                      :rules="[required, emailRule]" type="email" />
                  </v-col>
                </v-row>

              </v-form>
              <div class="d-flex justify-space-between mt-4 pb-4">
                <v-btn text @click="step = 3">Zurück</v-btn>
                <v-btn color="primary" @click="nextStep(4)">Weiter</v-btn>
              </div>
            </v-stepper-content>

            <!-- ─── STEP 5 – Unterschriftsberechtigte Personen ───────────────── -->
            <v-stepper-content step="5">
              <v-form ref="form5" v-model="formValid[5]" lazy-validation>

                <div class="body-2 grey--text mb-4">
                  Für die Kreditkartenakzeptanzen müssen die persönlichen Daten, also Privatadresse plus
                  Personalausweiskopie der unterschriftsberechtigten Personen hinterlegt werden.
                </div>

                <v-card v-for="(signer, idx) in signers" :key="idx" class="mb-4 pa-4" outlined>
                  <div class="d-flex justify-space-between align-center mb-3">
                    <div class="subtitle-1 font-weight-medium">Unterschriftsberechtigte Person ({{ idx + 1 }})</div>
                    <v-btn v-if="idx > 0" icon small color="error" @click="removeSigner(idx)">
                      <v-icon small>{{ mdiClose }}</v-icon>
                    </v-btn>
                  </div>

                  <v-row dense class="mb-4">
                    <v-col cols="12" sm="6">
                      <v-text-field v-model="signer.firstName" :label="`Vorname${idx === 0 ? ' *' : ''}`" outlined dense
                        :rules="idx === 0 ? [required] : []" />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field v-model="signer.lastName" :label="`Nachname${idx === 0 ? ' *' : ''}`" outlined dense
                        :rules="idx === 0 ? [required] : []" />
                    </v-col>
                  </v-row>

                  <div class="body-2 mb-1">Politisch exponierte Person? *</div>
                  <v-radio-group v-model="signer.pep" :rules="idx === 0 ? [required] : []" row class="mt-0 mb-3">
                    <v-radio label="Nein" :value="false" />
                    <v-radio label="Ja" :value="true" />
                  </v-radio-group>

                  <div class="subtitle-2 mb-2">Privatanschrift</div>
                  <v-row dense class="mb-4">
                    <v-col cols="12" sm="5">
                      <v-text-field v-model="signer.street" :label="`Straße + Nr.${idx === 0 ? ' *' : ''}`" outlined dense
                        :rules="idx === 0 ? [required] : []" />
                    </v-col>
                    <v-col cols="6" sm="2">
                      <v-text-field v-model="signer.postcode" :label="`PLZ${idx === 0 ? ' *' : ''}`" outlined dense
                        :rules="idx === 0 ? [required] : []" />
                    </v-col>
                    <v-col cols="6" sm="3">
                      <v-text-field v-model="signer.locality" :label="`Ort${idx === 0 ? ' *' : ''}`" outlined dense
                        :rules="idx === 0 ? [required] : []" />
                    </v-col>
                    <v-col cols="12" sm="2">
                      <v-select v-model="signer.country" label="Land" outlined dense :items="countries" />
                    </v-col>
                  </v-row>

                  <v-row dense class="mb-4">
                    <v-col cols="12" sm="4">
                      <v-text-field v-model="signer.birthDate" :label="`Geburtsdatum${idx === 0 ? ' *' : ''}`" outlined dense
                        placeholder="TT.MM.JJJJ" :rules="idx === 0 ? [required, dateRule] : [optionalDateRule]" />
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-text-field v-model="signer.birthPlace" :label="`Geburtsort${idx === 0 ? ' *' : ''}`" outlined dense
                        :rules="idx === 0 ? [required] : []" />
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-select v-model="signer.nationality" label="Staatsangehörigkeit" outlined dense :items="countries" />
                    </v-col>
                  </v-row>

                  <v-row dense class="mb-4">
                    <v-col cols="12" sm="3">
                      <v-select v-model="signer.documentType" :label="`Legitimationsdokument${idx === 0 ? ' *' : ''}`"
                        outlined dense :items="documentTypes" :rules="idx === 0 ? [required] : []" />
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field v-model="signer.documentNo" :label="`Ausweisnummer${idx === 0 ? ' *' : ''}`" outlined dense
                        :rules="idx === 0 ? [required] : []" />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field v-model="signer.issuingAuthority" :label="`Ausstellende Behörde${idx === 0 ? ' *' : ''}`"
                        outlined dense :rules="idx === 0 ? [required] : []" />
                    </v-col>
                  </v-row>

                  <v-row dense class="mb-4">
                    <v-col cols="12" sm="6">
                      <v-text-field v-model="signer.issueDate" :label="`Ausstellungsdatum${idx === 0 ? ' *' : ''}`" outlined dense
                        placeholder="TT.MM.JJJJ" :rules="idx === 0 ? [required, dateRule] : [optionalDateRule]" />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field v-model="signer.expiryDate" :label="`Ablaufdatum${idx === 0 ? ' *' : ''}`" outlined dense
                        placeholder="TT.MM.JJJJ" :rules="idx === 0 ? [required, dateRule] : [optionalDateRule]" />
                    </v-col>
                  </v-row>
                </v-card>

                <v-btn v-if="signers.length < 3" text color="primary" @click="addSigner" class="mb-4">
                  <v-icon left>{{ mdiPlus }}</v-icon>
                  Weitere unterschriftsberechtigte Person hinzufügen
                </v-btn>

                <v-alert type="info" outlined dense class="mt-2 mb-3">
                  <strong>Ausweiskopie hochladen:</strong> Bitte laden Sie für jede unterschriftsberechtigte Person eine Ausweiskopie über folgenden Link hoch:
                  <a href="https://dateiaustausch.wolff.holdings/s/eWYTs863LP4eELe" target="_blank">
                    Dateiupload öffnen
                  </a>
                </v-alert>

              </v-form>
              <div class="d-flex justify-space-between mt-4 pb-4">
                <v-btn text @click="step = 4">Zurück</v-btn>
                <v-btn color="primary" @click="nextStep(5)">Weiter</v-btn>
              </div>
            </v-stepper-content>

            <!-- ─── STEP 6 – Abschluss ────────────────────────────────────────── -->
            <v-stepper-content step="6">
              <v-form ref="form6" v-model="formValid[6]" lazy-validation>

                <div class="text-h6 mb-4">Zusammenfassung</div>
                <div class="body-2 grey--text mb-4">Bitte überprüfen Sie Ihre Eingaben.</div>

                <!-- Summary table -->
                <v-card outlined class="mb-4 pa-3">
                  <div class="subtitle-2 mb-2">Produkte</div>
                  <div class="body-2">{{ productsSummary }}</div>
                </v-card>

                <v-card outlined class="mb-4 pa-3">
                  <div class="subtitle-2 mb-2">Organisation</div>
                  <table class="summary-table body-2">
                    <tr><td>Name:</td><td><strong>{{ org.name }}</strong></td></tr>
                    <tr><td>Kurzname:</td><td><strong>{{ org.shortName }}</strong></td></tr>
                    <tr v-if="org.region"><td>Landeskirche / Erzbistum:</td><td><strong>{{ org.region }}</strong></td></tr>
                    <tr v-if="org.district"><td>Kirchenkreis / Bistum:</td><td><strong>{{ org.district }}</strong></td></tr>
                    <tr><td>Rechtsform:</td><td><strong>{{ org.legalForm === 'Sonstige' ? org.legalFormOther : org.legalForm }}</strong></td></tr>
                    <tr><td>Straße:</td><td><strong>{{ org.street }}</strong></td></tr>
                    <tr><td>PLZ:</td><td><strong>{{ org.postcode }}</strong></td></tr>
                    <tr><td>Ort:</td><td><strong>{{ org.locality }}</strong></td></tr>
                    <tr><td>Land:</td><td><strong>{{ org.country }}</strong></td></tr>
                    <tr><td>Gründungsdatum:</td><td><strong>{{ org.foundingDate }}</strong></td></tr>
                    <tr><td>Register:</td><td><strong>{{ org.register }}</strong></td></tr>
                    <tr v-if="org.registerNumber"><td>Register-Nr.:</td><td><strong>{{ org.registerNumber }}</strong></td></tr>
                    <tr v-if="org.registerCourt"><td>Registergericht:</td><td><strong>{{ org.registerCourt }}</strong></td></tr>
                    <tr v-if="org.creditorId"><td>Gläubiger-ID:</td><td><strong>{{ org.creditorId }}</strong></td></tr>
                    <tr v-if="org.websiteUrl"><td>Website:</td><td><strong>{{ org.websiteUrl }}</strong></td></tr>
                    <tr v-if="org.serviceContractSelf === 'nein'">
                      <td>Mutterorganisation:</td><td><strong>{{ org.parentOrgName }}</strong></td>
                    </tr>
                  </table>
                  <v-alert type="info" outlined dense class="mt-3 mb-0">
                    Erinnerung: Vertretungsberechtigungen und Ausweiskopien hier hochladen -
                    <a href="https://dateiaustausch.wolff.holdings/s/eWYTs863LP4eELe" target="_blank">
                      Dateiupload öffnen
                    </a>
                  </v-alert>
                </v-card>

                <v-card outlined class="mb-4 pa-3">
                  <div class="subtitle-2 mb-2">Kontoverbindungen</div>
                  <table class="summary-table body-2">
                    <tr><td>Zahlungseingänge:</td><td><strong>{{ bank.paymentOwner }}</strong></td></tr>
                    <tr><td></td><td><strong>{{ bank.paymentBankName }}</strong></td></tr>
                    <tr><td></td><td><strong>{{ bank.paymentIban }}</strong></td></tr>
                    <tr><td>Betriebskosten:</td><td><strong>{{ bank.sepaOwner }}</strong></td></tr>
                    <tr><td></td><td><strong>{{ bank.sepaBankName }}</strong></td></tr>
                    <tr><td></td><td><strong>{{ bank.sepaIban }}</strong></td></tr>
                  </table>
                </v-card>

                <v-card outlined class="mb-4 pa-3">
                  <div class="subtitle-2 mb-2">Ansprechpartner</div>
                  <table class="summary-table body-2">
                    <tr><td>Vorname:</td><td><strong>{{ contact.firstName }}</strong></td></tr>
                    <tr><td>Nachname:</td><td><strong>{{ contact.lastName }}</strong></td></tr>
                    <tr><td>Funktion:</td><td><strong>{{ contact.role }}</strong></td></tr>
                    <tr><td>Telefon:</td><td><strong>{{ contact.phone }}</strong></td></tr>
                    <tr><td>E-Mail Ansprechpartner / Administrator:</td><td><strong>{{ contact.email }}</strong></td></tr>
                    <tr><td>E-Mail Rechnungen:</td><td><strong>{{ contact.invoiceEmail }}</strong></td></tr>
                  </table>
                </v-card>

                <v-card outlined class="mb-4 pa-3">
                  <div class="subtitle-2 mb-2">Unterschriftsberechtigte Person{{ signers.length > 1 ? 'en' : '' }}</div>
                  <div v-for="(signer, idx) in signers" :key="idx" :class="{ 'mt-3': idx > 0 }">
                    <div class="body-2 font-weight-medium mb-1">Person {{ idx + 1 }}</div>
                    <table class="summary-table body-2">
                      <tr><td>Name:</td><td><strong>{{ signer.firstName }} {{ signer.lastName }}</strong></td></tr>
                      <tr><td>Adresse:</td><td><strong>{{ signer.street }}, {{ signer.postcode }} {{ signer.locality }}</strong></td></tr>
                      <tr><td>Geboren:</td><td><strong>am {{ signer.birthDate }} in {{ signer.birthPlace }}</strong></td></tr>
                      <tr><td>Legitimiert durch:</td><td><strong>{{ documentTypeLabel(signer.documentType) }}</strong></td></tr>
                    </table>
                  </div>
                </v-card>

                <v-divider class="my-4" />

                <v-text-field v-model="finish.discountCode" label="Rabattcode" outlined dense class="mb-3" style="max-width:300px" />
                <v-textarea v-model="finish.comments" label="Kommentar" outlined dense rows="3" class="mb-3" />

                <v-checkbox v-model="finish.acceptDataProcessing" :rules="[v => !!v || 'Zustimmung ist erforderlich']">
                  <template v-slot:label>
                    Ich habe die <a href="https://digitalwolff.de/privacy-policy/" target="_blank" @click.stop>Datenschutzerklärung</a> gelesen und stimme der Verarbeitung meiner personenbezogenen Daten zu. *
                  </template>
                </v-checkbox>

                <v-checkbox v-model="finish.acceptAdminFee"
                  :rules="[v => !!v || 'Zustimmung zur Verwaltungspauschale ist erforderlich']"
                  label="Ich akzeptiere, dass die Verwaltungspauschale in Höhe von 50€ mit Einreichen dieses Formulars fällig und in Rechnung gestellt wird.*" />

              </v-form>
              <div class="d-flex justify-space-between mt-4 pb-4">
                <v-btn text @click="step = 5">Zurück</v-btn>
                <v-btn color="primary" :loading="loading" :disabled="loading" @click="submit">Absenden</v-btn>
              </div>
            </v-stepper-content>

          </v-stepper-items>
        </v-stepper>

      </v-container>
    </v-main>
  </div>
</template>

<script>
import axios from 'axios'
import config from '@/config'
import { electronicFormatIBAN, isValidIBAN } from 'ibantools'
import { mdiCheckCircle, mdiClose, mdiPlus } from '@mdi/js'
import Logo from '@/components/icons/Logo'

function emptySigner () {
  return {
    firstName: '',
    lastName: '',
    pep: null,
    street: '',
    postcode: '',
    locality: '',
    country: 'DE',
    birthDate: '',
    birthPlace: '',
    nationality: 'DE',
    documentType: '',
    documentNo: '',
    issuingAuthority: '',
    issueDate: '',
    expiryDate: '',
  }
}

const DATE_RE = /^\d{2}\.\d{2}\.\d{4}$/

export default {
  name: 'ContractRequest',

  components: { Logo },

  data () {
    return {
      step: 1,
      loading: false,
      submitError: null,
      success: false,
      mdiCheckCircle,
      mdiClose,
      mdiPlus,

      products: { ws: false, wa: false, va: false, kg: false, kb: false, sd: false, sp: false, wt: false, so: false },
      showProductAlert: false,

      // Tracks which steps the user has already tried to leave/submit, so error
      // icons don't light up on steps nobody has touched yet.
      visited: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
      formValid: { 2: true, 3: true, 4: true, 5: true, 6: true },

      org: {
        name: '',
        shortName: '',
        legalForm: '',
        legalFormOther: '',
        region: '',
        district: '',
        street: '',
        postcode: '',
        locality: '',
        country: 'DE',
        foundingDate: '',
        register: '',
        registerNumber: '',
        registerCourt: '',
        creditorId: '',
        websiteUrl: '',
        serviceContractSelf: null,
        parentOrgName: '',
      },

      bank: {
        paymentOwner: '',
        paymentBankName: '',
        paymentIban: '',
        sepaOwner: '',
        sepaBankName: '',
        sepaIban: '',
      },

      contact: {
        firstName: '',
        lastName: '',
        role: '',
        phone: '',
        email: '',
        invoiceEmail: '',
      },

      signers: [emptySigner()],

      finish: { discountCode: '', comments: '', acceptDataProcessing: false, acceptAdminFee: false },

      legalForms: [
        'Körperschaft öffentlichen Rechts',
        'Verein',
        'Stiftung privaten Rechts',
        'Stiftung öffentlichen Rechts',
        'gGmbH',
        'GmbH',
        'Sonstige',
      ],

      documentTypes: [
        { text: 'Personalausweis', value: 'ID' },
        { text: 'Reisepass', value: 'P' },
        { text: 'Sonstiges', value: 'other' },
      ],

      countries: [
        { text: 'Deutschland', value: 'DE' },
        { text: 'Österreich', value: 'AT' },
        { text: 'Schweiz', value: 'CH' },
        { text: 'Frankreich', value: 'FR' },
        { text: 'Niederlande', value: 'NL' },
        { text: 'Belgien', value: 'BE' },
        { text: 'Dänemark', value: 'DK' },
        { text: 'Polen', value: 'PL' },
        { text: 'Tschechien', value: 'CZ' },
        { text: 'Italien', value: 'IT' },
        { text: 'Spanien', value: 'ES' },
        { text: 'Luxemburg', value: 'LU' },
        { text: 'USA', value: 'US' },
        { text: 'Großbritannien', value: 'GB' },
        { text: 'Sonstiges', value: 'OT' },
      ],
    }
  },

  watch: {
    step (newStep, oldStep) {
      this.$set(this.visited, oldStep, true)
    },
  },

  computed: {
    anyProductSelected () {
      return Object.values(this.products).some(Boolean)
    },

    productsSummary () {
      const parts = []
      if (this.products.ws) parts.push('spende.app')
      if (this.products.wa) parts.push('kollekte.app')
      if (this.products.va) parts.push('veranstaltung.app')
      if (this.products.kg) parts.push('kirchgeld.digital')
      if (this.products.kb) parts.push('Digitaler Klingelbeutel')
      if (this.products.sd) parts.push('Digitale Spendendose')
      if (this.products.sp) parts.push('Digitale Spendensäule')
      if (this.products.wt) parts.push('spende.tap')
      if (this.products.so) parts.push('Sonderanfertigung')
      return parts.join(', ') || '—'
    },
  },

  methods: {
    required (v) {
      if (v === null || v === undefined || v === '') return 'Dieses Feld ist erforderlich'
      return true
    },

    dateRule (v) {
      if (!v) return 'Datum ist erforderlich'
      if (!DATE_RE.test(v)) return 'Format: TT.MM.JJJJ'
      return this.parseDate(v) !== null || 'Ungültiges Datum'
    },

    optionalDateRule (v) {
      if (!v) return true
      if (!DATE_RE.test(v)) return 'Format: TT.MM.JJJJ'
      return this.parseDate(v) !== null || 'Ungültiges Datum'
    },

    ibanRule (v) {
      if (!v) return 'IBAN ist erforderlich'
      const cleaned = v.replace(/\s/g, '')
      return isValidIBAN(electronicFormatIBAN(cleaned)) || 'Ungültige IBAN'
    },

    emailRule (v) {
      if (!v) return 'E-Mail ist erforderlich'
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Ungültige E-Mail-Adresse'
    },

    urlRule (v) {
      if (!v) return true
      try { return !!new URL(v) } catch { return 'Ungültige URL (z. B. https://www.example.de)' }
    },

    formatIban (v) {
      if (!v) return v
      const cleaned = v.replace(/\s/g, '')
      return isValidIBAN(electronicFormatIBAN(cleaned)) ? electronicFormatIBAN(cleaned) : cleaned
    },

    documentTypeLabel (val) {
      const found = this.documentTypes.find(d => d.value === val)
      return found ? found.text : val
    },

    parseDate (str) {
      if (!str || !DATE_RE.test(str)) return null
      const [d, m, y] = str.split('.')
      const iso = `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`
      const dt = new Date(iso)
      if (isNaN(dt.getTime()) || dt.getMonth() + 1 !== Number(m) || dt.getDate() !== Number(d)) return null
      return iso
    },

    addSigner () {
      if (this.signers.length < 3) this.signers.push(emptySigner())
    },

    removeSigner (idx) {
      this.signers.splice(idx, 1)
    },

    stepHasError (n) {
      if (!this.visited[n]) return false
      return n === 1 ? !this.anyProductSelected : !this.formValid[n]
    },

    tryNextStep1 () {
      this.$set(this.visited, 1, true)
      if (!this.anyProductSelected) {
        this.showProductAlert = true
        return
      }
      this.nextStep(1)
    },

    async nextStep (current) {
      this.$set(this.visited, current, true)
      const form = this.$refs[`form${current}`]
      if (form && !form.validate()) return
      this.step = current + 1
    },

    // Validates every step regardless of which one is currently active, since
    // steps are freely clickable and a user may jump straight to step 6.
    // Returns the number of the first invalid step, or null if all are valid.
    validateAllSteps () {
      if (!this.anyProductSelected) {
        this.showProductAlert = true
        this.$set(this.visited, 1, true)
        return 1
      }
      for (let n = 2; n <= 6; n++) {
        this.$set(this.visited, n, true)
        const form = this.$refs[`form${n}`]
        if (form && !form.validate()) return n
      }
      return null
    },

    buildPayload () {
      const productsRequested = {}
      if (this.products.ws) productsRequested.ws = 1
      if (this.products.wa) productsRequested.wa = 1
      if (this.products.va) productsRequested.va = 1
      if (this.products.kg) productsRequested.kg = 1
      if (this.products.kb) productsRequested.kb = 1
      if (this.products.sd) productsRequested.sd = 1
      if (this.products.sp) productsRequested.sp = 1
      if (this.products.wt) productsRequested.wt = 1
      if (this.products.so) productsRequested.so = 1

      const persons = []

      persons.push({
        types: ['contact', 'administrator'],
        first_name: this.contact.firstName,
        last_name: this.contact.lastName,
        role: this.contact.role,
        phone_number: this.contact.phone,
        email: this.contact.email,
        addresses: [{
          type: 'organization',
          name: this.org.name,
          address: this.org.street,
          postcode: this.org.postcode,
          locality: this.org.locality,
          country: this.org.country,
        }],
      })

      persons.push({
        types: ['invoice'],
        first_name: this.contact.firstName,
        last_name: this.contact.lastName,
        email: this.contact.invoiceEmail,
      })

      for (const signer of this.signers) {
        persons.push({
          types: ['authorized_signer'],
          first_name: signer.firstName,
          last_name: signer.lastName,
          pep: signer.pep,
          addresses: [{
            type: 'authorizer',
            address: signer.street,
            postcode: signer.postcode,
            locality: signer.locality,
            country: signer.country,
          }],
          legitimizations: [{
            date_of_birth: this.parseDate(signer.birthDate),
            place_of_birth: signer.birthPlace,
            nationality: signer.nationality,
            document_type: signer.documentType,
            document_no: signer.documentNo,
            issuing_authority: signer.issuingAuthority,
            issued_date: this.parseDate(signer.issueDate),
            expiry_date: this.parseDate(signer.expiryDate),
          }],
        })
      }

      const bankAccounts = [
        {
          types: ['payment'],
          owner: this.bank.paymentOwner,
          bank_name: this.bank.paymentBankName,
          iban: this.formatIban(this.bank.paymentIban),
        },
        {
          types: ['sepa'],
          owner: this.bank.sepaOwner,
          bank_name: this.bank.sepaBankName,
          iban: this.formatIban(this.bank.sepaIban),
        },
      ]

      return {
        products_requested: productsRequested,
        organization_name: this.org.name,
        short_organization_name: this.org.shortName,
        legal_form: this.org.legalForm === 'Sonstige' ? this.org.legalFormOther : this.org.legalForm,
        region: this.org.region || null,
        district: this.org.district || null,
        founding_date: this.parseDate(this.org.foundingDate),
        register: this.org.register,
        register_number: this.org.registerNumber || null,
        register_court: this.org.registerCourt || null,
        creditor_id: this.org.creditorId || null,
        website_url: this.org.websiteUrl || null,
        purpose_on_account_statement: 'Spende',
        individual: true,
        service_contract_self: this.org.serviceContractSelf === 'ja',
        parent_organization_name: this.org.serviceContractSelf === 'nein' ? this.org.parentOrgName : null,
        multi_authorizers: this.signers.length > 1,
        referral_source: null,
        discount_code: this.finish.discountCode || null,
        comments: this.finish.comments || null,
        accept_data_processing: this.finish.acceptDataProcessing,
        accept_admin_fee: this.finish.acceptAdminFee,
        persons,
        bank_accounts: bankAccounts,
      }
    },

    async submit () {
      if (this.loading) return

      const invalidStep = this.validateAllSteps()
      if (invalidStep) {
        this.step = invalidStep
        window.scrollTo(0, 0)
        return
      }

      this.loading = true
      this.submitError = null

      try {
        const api = axios.create({ baseURL: config.backend.rest })
        await api.post('contract/application/customer/', this.buildPayload())
        this.success = true
        window.scrollTo(0, 0)
      } catch (e) {
        const detail = e.response?.data
        if (detail && typeof detail === 'object') {
          this.submitError = Object.entries(detail)
            .map(([k, v]) => `${k}: ${Array.isArray(v) ? v.join(', ') : v}`)
            .join(' | ')
        } else {
          this.submitError = 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.'
        }
        window.scrollTo(0, 0)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.summary-table {
  width: 100%;
  border-collapse: collapse;
}
.summary-table td {
  padding: 3px 8px 3px 0;
  vertical-align: top;
}
.summary-table td:first-child {
  width: 220px;
  color: #666;
  white-space: nowrap;
}
</style>
